import { StateCreator } from 'zustand';

export interface SessionZustandSlice {
    token: string | null;
    favouriteEdition: string;
    favouriteDate: string | null;

    updateSessionToken: (token: string | null) => void;
    updateSessionFavouriteEdition: (edition: string) => void;
    updateSessionFavouriteDate: (date: string | null) => void;

    _hasHydrated: boolean
    setHasHydrated: (state: any) => void
}

export const createSessionZustandSlice: StateCreator<SessionZustandSlice> = (set, get) => ({
    token: null,
    favouriteEdition: 'DLZ',
    favouriteDate: null,

    updateSessionToken: (token: string | null) => {
        const currentToken = get().token;

        if (currentToken !== token) {
            set(() => ({ token }));
        } else {
            //console.log("Session token unchanged.");
        }
    },
    updateSessionFavouriteEdition: (favouriteEdition: string) => {
        //console.log("Store - SessionZustandSlice - favouriteEdition updated", favouriteEdition),
        set(() => ({ favouriteEdition: favouriteEdition }))
    },
    
    updateSessionFavouriteDate: (favouriteDate: string | null) => {
        //console.log("Store - SessionZustandSlice - favouriteDate updated", favouriteDate),
        set(() => ({ favouriteDate: favouriteDate }))
    },

    _hasHydrated: false,
    setHasHydrated: (state: any) => {
        set({
            _hasHydrated: state
        });
    },
});